/** @jsxImportSource @emotion/react */

import { TextareaAutosizeProps } from '@mui/material/TextareaAutosize'
import { FormControl, InputLabel, TextareaAutosize as MuiTextareaAutosize } from '@mui/material'
import Typography from '@mui/material/Typography'
import { FieldValidator } from 'final-form'
import { FC } from 'react'
import { useField } from 'react-final-form'
import * as classes from './styles'

interface IProps extends TextareaAutosizeProps {
  className?: string
  name?: string
  value?: string
  label?: string
  placeholder?: string
  validate?: FieldValidator<string>
}

//TODO this new component should be applied everywhere
const TextareaAutosize: FC<IProps> = ({ className, name = 'textareaAutosize', label, value, validate, ...props }) => {
  const { input, meta } = useField<string>(name, { validate })

  return (
    <FormControl>
      {label && (
        <InputLabel shrink htmlFor={props.id || name || 'textarea-label'}>
          {label}
        </InputLabel>
      )}
      <MuiTextareaAutosize
        {...input}
        id={props.id || name}
        value={value ?? input.value}
        css={[classes.textArea, meta.touched && meta.error && classes.textAreaError]}
        className={className}
        {...props}
      />
      {meta.touched && meta.error && (
        <Typography variant="body3" css={classes.textAreaHelperText}>
          Required
        </Typography>
      )}
    </FormControl>
  )
}
export default TextareaAutosize
